import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsAccountMessages = defineMessages("settings-account", en);
